import ready from '@ryanmorr/ready';

(() => {
  ready('[data-slider]', (element) => {
    import('./slider').then((Module) => {
      new Module.default(
        element,
        element.dataset.options ? JSON.parse(element.dataset.options) : {},
      );
    });
  });
})();
